import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { LoaderBarComponent } from '@shared/lib/components/loader-bar/loader-bar.component';
import { PageHeaderComponent } from '@shared/lib/components/page-header/page-header.component';
import { RedirectComponent } from '@shared/lib/components/redirect/redirect.component';
import { XsrfInterceptor } from '@shared/lib/interceptors/xsrf.interceptor';
import { RefreshingLoadingService } from '@shared/lib/services/refreshing-loading.service';
import { SharedLoginConstants } from '@shared/lib/shared-login.constants';
import { UrlModule } from '@usana/ux/common/url';
import { UsanaMarketsRoutingModule } from '@usana/ux/markets/routing';
import { SsoAuthInterceptor, SsoAuthModule } from '@usana/ux/sso-auth';
import { SsoFullStoryModule } from '@usana/ux/sso-auth/fullstory';
import { PackagePrimeMode, TranslationConfig } from '@usana/ux/translations';
import { UsanaTranslationsMarketInformedModule } from '@usana/ux/translations/market-informed';
import { UniversalButtonModule } from '@usana/ux/universal-components/button';
import { UniversalFormInputPasswordModule } from '@usana/ux/universal-components/input/password';
import { UniversalFormInputTextModule } from '@usana/ux/universal-components/input/text';
import { LoginPageComponent } from './components/login-page/login-page.component';

const components = [LoginPageComponent, LoaderBarComponent, PageHeaderComponent, RedirectComponent];

@NgModule({
  declarations: components,
  exports: components,
  imports: [
    CommonModule,
    SsoAuthModule,
    ReactiveFormsModule,
    UniversalButtonModule,
    UniversalFormInputTextModule,
    UniversalFormInputPasswordModule,
    UsanaTranslationsMarketInformedModule,
    UsanaMarketsRoutingModule,
    RouterModule,
    SsoFullStoryModule,
    UrlModule,
  ],
  providers: [
    // LoginService,
    { provide: HTTP_INTERCEPTORS, useClass: SsoAuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: XsrfInterceptor, multi: true },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class SharedModule {
  constructor(translationConfig: TranslationConfig, refreshingLoadingService: RefreshingLoadingService) {
    translationConfig.addPackage({
      pkg: SharedLoginConstants.TRANSLATION_PKG,
      primeMode: PackagePrimeMode.ON_INIT,
      showTagWhenMissing: true,
    });

    refreshingLoadingService.attemptRefresh();
  }
}
